import React, { useEffect } from "react";

import SentNotificationsPage from "../../components/APanel/SentNotifications/SentNotificationsPage";

// Admin / Manager → Notificări: notificările trimise din aplicație, cu filtrele în rândul de sus.
export default function APNotifications() {
   useEffect(() => {
      document.title = "Instruire Auto | Notificări";
   }, []);

   return (
      <main className="main">
         <section className="page-wrapper">
            <SentNotificationsPage />
         </section>
      </main>
   );
}
